import * as React from 'react';
import gql from 'graphql-tag';
import { compose, graphql, MutationFunc } from 'react-apollo';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import CartService from '../../../../..//services/CartService';
import CountryService from '../../../../../services/CountryService';
import AuthService from '../../../../../services/AuthService';
import FlashStore from '../../../../../services/FlashStore';

import GoogleTagManagerService from '../../../../../services/GoogleTagManagerService';

const Auth0LoginMutation = gql`
  mutation auth0Login(
    $auth0AccessToken: String!
    $invoiceCountry: String!
  ) {
    auth0Login (
      auth0AccessToken: $auth0AccessToken
      invoiceCountry: $invoiceCountry
    ) {
      token,
      user {
        id
        
        email
        phone
        
        receiveNewsletter
        
        companyInformation
        companyName
        companyRegistrationNumber
        companyVatNumber

        invoiceFirstName
        invoiceLastName
        
        invoiceStreet
        invoiceHouseNumber
        invoiceAddressLine1
        invoiceAddressLine2
        invoiceZip
        invoiceCity
        invoiceCountyState
        invoiceCountry

        anotherDeliveryAddress
        deliveryStreet
        deliveryHouseNumber
        deliveryAddressLine1
        deliveryAddressLine2
        deliveryZip
        deliveryCity
        deliveryCountyState
        deliveryCountry

        saleTaxCertificate

        discount

        customerGroup {
          id
          name
          discount
        }

        customerGroups {
          id
          name
          discount
          description
          fields
        }

        customerGroupsData
      }
      country {
        id
        parentCountryId
        name
        title
        details
        slug
        VATrate
        currency
        language
        code
        flag
        weightUnit
        states {
          id
          name
          title
          vatRate
        }
      }
    }
  }
`;

interface INotLoggedProps extends RouteComponentProps {
  type: 'button' | 'icon';
  isOpened: boolean;
  toggleOpen: () => void;
  refetch?: () => void;
  click?: boolean;
  auth0Login: MutationFunc;
}

const NotLogged = (props: INotLoggedProps) => {
  const { auth0Login, type, click } = props;
  const [clicked, doClick] = React.useState(false);
  const ref = React.useRef<HTMLButtonElement>(null);

  const { loginWithPopup, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const country = CountryService.GetInstance();
  if (!country.country) {
    return null;
  }
  
  const { name: invoiceCountry, countryCode } = country;
  const returnTo = process.env.REACT_APP_AUTH0_REDIRECT;
  
  const doLogin = async (showSignup: boolean = false) => {
    if (showSignup) {
      GoogleTagManagerService.startRegistration();
    } else {
      GoogleTagManagerService.startSignIn();
    }
    if (!isAuthenticated) {
      await loginWithPopup({ appState: { returnTo }, screen_hint: showSignup ? 'signup' : 'login' });
    }

    const auth0AccessToken = await getAccessTokenSilently();
    localStorage.setItem('auth0accessToken', auth0AccessToken);
    let login = null; 

    try {
      login = await auth0Login({ variables: { auth0AccessToken, invoiceCountry } });
    } catch (e) {
      FlashStore.GetInstance().showMessage('Login failed. Please try later or contact support.', 'error');
      return;
    }

    const result = login && login.data.auth0Login;
    const { user: { invoiceFirstName, invoiceLastName, invoiceCity, invoiceZip, phone } } = result;

    const invalidUser = [
      invoiceFirstName,
      invoiceLastName,
      invoiceCity,
      invoiceZip,
      phone,
    ].some((v: string | undefined | null) => !v);
    
    // if (invalidUser) {
    //   FlashStore.GetInstance().showMessage('If you want use your profile, fill required information please!', 'warning');
    //   AuthService.GetInstance().setLogin(result);
      
    //   if (props.refetch) {
    //     await props.refetch();
    //   }

    //   props.history.push(`/${result.country.code}/user/data`);
    //   return;
    // }
    
    AuthService.GetInstance().setLogin(result);
    FlashStore.GetInstance().showMessage('You are logged in', 'success');
    CartService.GetInstance().setCustomerData(result.user);

    CountryService.GetInstance().setCountry(result.country, true);

    if (showSignup) {
      GoogleTagManagerService.registrationCompleted();
    } else {
      GoogleTagManagerService.signedIn();
    }
    
    if (props.refetch) {
      await props.refetch();
    }
      // Country code urls are not used anymore
      // props.history.push(`/${result.country.code}`);
      const params = new URLSearchParams(props.location.search);
      const currentCurrencyCode = params.get('currency');
      const countryCurrencyCode = result.country && result.country.currency && result.country.currency.value;
      if (currentCurrencyCode !== countryCurrencyCode) {
        if (CountryService.GetInstance().currencyCodePageParam) {
          params.set('currency', countryCurrencyCode);
        } else {
          params.delete('currency');
        }
        const newParamString = params.toString();
        props.history.push(`${props.location.pathname}${newParamString.length > 0 ? `?${newParamString}` : ''}`);
      }
  };
  
  const doSignUp = () => doLogin(true);

  if (click && !clicked ) {
    doLogin();
    doClick(true);
  }
  
  switch (type) {
    case 'button':
      return (
        <button
          ref={ref}
          className={'btn btn--proceed btn--fullMd'}
          onClick={() => doLogin()}
        >
          Login
        </button>
      );

    default:
      return (
        <>
          <p
            className="header__userActions__action"
            onClick={() => doLogin()}
          >
            Sign In
          </p>
          <p
            className="header__userActions__action"
            onClick={() => doSignUp()}
          >
            Create Account
          </p>
        </>
      );
  }
};

interface IInputProps {
  children?: any;
}

interface IResponse {
  data: any;
}

export default compose(
    graphql<IInputProps, IResponse>(Auth0LoginMutation, {
      name: 'auth0Login'
    }),
  )(withRouter(NotLogged));


// WEBPACK FOOTER //
// ./src/components/Header/components/Account/components/NotLogged.tsx